import { useEffect, useState, useCallback } from "react";
import api, { num } from "@/lib/api";
import { Card, PageHeader, Btn, Input, Select, EmptyState, Th, Td } from "@/components/admin/ui";

export default function AuditLogs() {
  const [data, setData] = useState({ items: [], total: 0, actions: [] });
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({ user_email: "", action: "", date_from: "", date_to: "" });

  const load = useCallback(() => {
    const p = new URLSearchParams({ page, limit: 50 });
    Object.entries(filters).forEach(([k, v]) => v && p.append(k, v));
    api.get(`/audit-logs?${p.toString()}`).then((r) => setData(r.data)).catch(() => {});
  }, [page, filters]);
  useEffect(() => { load(); }, [load]);

  const pages = Math.ceil(data.total / 50) || 1;

  return (
    <div className="space-y-6">
      <PageHeader title="Audit Log" subtitle={`${num(data.total)} recorded administrative actions`} />
      <Card className="p-4">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <Input label="User email" data-testid="audit-user-filter" value={filters.user_email} onChange={(e) => { setPage(1); setFilters({ ...filters, user_email: e.target.value }); }} placeholder="owner@…" />
          <Select label="Action" data-testid="audit-action-filter" value={filters.action} onChange={(e) => { setPage(1); setFilters({ ...filters, action: e.target.value }); }}>
            <option value="">All actions</option>{data.actions.map((a) => <option key={a} value={a}>{a.replace(/_/g, " ")}</option>)}
          </Select>
          <Input label="From" type="date" data-testid="audit-from" value={filters.date_from} onChange={(e) => { setPage(1); setFilters({ ...filters, date_from: e.target.value }); }} />
          <Input label="To" type="date" data-testid="audit-to" value={filters.date_to} onChange={(e) => { setPage(1); setFilters({ ...filters, date_to: e.target.value }); }} />
        </div>
      </Card>
      <Card>
        {data.items.length === 0 ? <EmptyState title="No audit entries" desc="Administrative actions like creating workers, editing campaigns and approving payments are recorded here." /> : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="border-b border-white/10"><tr><Th>When</Th><Th>User</Th><Th>Action</Th><Th>Entity</Th><Th>Details</Th></tr></thead>
              <tbody>
                {data.items.map((l) => (
                  <tr key={l.id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`audit-row-${l.id}`}>
                    <Td className="text-slate-400 text-xs whitespace-nowrap">{l.created_at?.slice(0, 16).replace("T", " ")}</Td>
                    <Td className="text-slate-300">{l.user_email || "system"}</Td>
                    <Td><span className="px-2 py-1 rounded-full bg-white/5 text-xs font-semibold text-[#1D4ED8]">{l.action?.replace(/_/g, " ")}</span></Td>
                    <Td className="text-slate-400">{l.entity_type} · {l.entity_id}</Td>
                    <Td className="text-slate-500 text-xs max-w-xs truncate">{l.new_value ? JSON.stringify(l.new_value) : "—"}</Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
      {pages > 1 && (
        <div className="flex items-center justify-center gap-2">
          <Btn variant="ghost" onClick={() => setPage(Math.max(1, page - 1))} disabled={page === 1}>Prev</Btn>
          <span className="text-sm text-slate-400">Page {page} / {pages}</span>
          <Btn variant="ghost" onClick={() => setPage(Math.min(pages, page + 1))} disabled={page === pages}>Next</Btn>
        </div>
      )}
    </div>
  );
}
